<script lang="ts">
    import Icon from '#cmp/shared/layout/Icon.svelte'
    import FaCircle from '~icons/fa-solid/circle'
    import type { ResolvedPathname } from '$app/types'
    interface Props {
        href: ResolvedPathname
        title: string
        onClick?: (e: MouseEvent) => void
    }

    let { href, title, onClick }: Props = $props()
</script>

<a {href} class="menu-link row" onclick={onClick}>
    <Icon size={0.4} style="color: var(--accent);">
        <FaCircle />
    </Icon>
    <h2 class="menu-title">{title}</h2>
</a>

<style lang="scss">
    .menu-title {
        font-size: 1rem;
        font-weight: normal;
    }
    .menu-link {
        gap: 0.9rem;
        align-items: center;
        transition: color 0.2s;
    }
    .menu-link:hover {
        color: var(--accent);
    }
</style>
